<template>
  <section v-if="!$store.state.utils.loaded" class="main-loading">
    <div style="position: relative">
      <!-- <div class="loader"></div> -->
      <h1
        style="
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        "
      >
        Mobile <strong class="d-block">Tech</strong> Zone
      </h1>
    </div>
  </section>
  <section v-else-if="$store.state.utils.processing" class="main-processing">
    <!-- <div class="main-spiner"></div> -->
  </section>
</template>

<script>
export default {
  name: "Loading",
  data() {
    return {};
  },

  mounted() {
    this.$nextTick(() => {});
  },

  methods: {},
};
</script>

<style>
.main-processing {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 99999;
  display: grid;
  backdrop-filter: blur(3px);
  align-content: center;
  justify-content: center;
}

.main-processing .main-spiner {
  position: relative;
  width: 70px;
  height: 70px;
  border: dotted 10px #000;
  border-radius: 50%;
  -webkit-animation: spiner 2.5s infinite linear;
  animation: spiner 2.5s infinite linear;
}

@-webkit-keyframes spiner {
   0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes spiner {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

/* **************************************** */

.main-loading {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 99999;
  display: grid;
  text-align: center;
  background-color: #333;
  color: #eee;
  align-content: center;
  justify-content: center;
}

.loader,
.loader:after {
  border-radius: 50%;
  width: 400px;
  height: 400px;
}

.loader {
  margin: 0 auto;
  position: relative;
  text-indent: -9999em;
  border-top: 1em solid transparent;
  border-right: 1em solid #ffffff;
  border-bottom: 1em solid transparent;
  border-left: 1em solid #ffffff;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: load8 2s infinite linear;
  animation: load8 2.5s infinite linear;
}

@-webkit-keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg) scale(1);
    filter: blur(0px);
  }
  40% {
    -webkit-transform: rotate(-30deg);
    transform: rotate(-30deg) scale(1.2);
    filter: blur(5px);
  }
  50% {
    -webkit-transform: rotate(30deg);
    transform: rotate(30deg) scale(1.3);
    filter: blur(5px);
  }
  60% {
    -webkit-transform: rotate(-30deg);
    transform: rotate(-30deg) scale(1.2);
    filter: blur(5px);
  }
  100% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg) scale(1);
    filter: blur;
  }
}
@keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg) scale(1);
    filter: blur(0px);
  }
  40% {
    -webkit-transform: rotate(-30deg);
    transform: rotate(-30deg) scale(1.2);
    filter: blur(5px);
  }
  50% {
    -webkit-transform: rotate(30deg);
    transform: rotate(30deg) scale(1.3);
    filter: blur(5px);
  }
  60% {
    -webkit-transform: rotate(-30deg);
    transform: rotate(-30deg) scale(1.2);
    filter: blur(5px);
  }
  100% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg) scale(1);
    filter: blur(0px);
  }
}
</style>
